import MediaPicker from '@/Components/inputs/MediaPicker';
import { ImagePreview } from '@/Components/preview/ImagePreview';
import { MimeTypeEnum } from '@/graphql/types';
import type { AssetNode } from '@/routes/dash/settings/-utils';
import { Box } from '@mui/material';
import DragDropWrapper from '../DragDropWrapper/DragDropWrapper';

type FileEventProps = {
  onClear: () => void;
  onFileSelect: (file: AssetNode | null) => void;
  buttonTitle?: string;
  buttonIcon?: React.JSX.Element;
  buttonStyle?: React.CSSProperties;
};

type Props = {
  fileEventProps: FileEventProps;
  onClear?: () => void;
  image?: AssetNode;
  disabled?: boolean;
};

const ImagePickerWithPreview = (props: Props) => {
  return (
    <DragDropWrapper
      disabled={props?.disabled}
      mimeTypes={['image/png', 'image/jpeg', 'image/gif', 'image/webp']}
      fileCallback={(data) => {
        props?.fileEventProps?.onFileSelect?.(data?.newMediaItem?.mediaItem as AssetNode);
      }}
    >
      <ImagePreview
        node={props?.image}
        onClear={
          !!props?.onClear || !!props?.fileEventProps?.onClear
            ? () => {
                props?.onClear?.();
                props?.fileEventProps?.onClear?.();
              }
            : undefined
        }
      />
      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
        {/* @ts-ignore */}
        <MediaPicker
          disabled={props?.disabled}
          mimeTypes={[MimeTypeEnum.ImageJpeg, MimeTypeEnum.ImagePng, MimeTypeEnum.ImageGif, MimeTypeEnum.ImageWebp]}
          {...props.fileEventProps}
          showThumbnailButton={false}
        />
      </Box>
    </DragDropWrapper>
  );
};

export default ImagePickerWithPreview;
